export type UserIdentifier = number | string | null | undefined;

export const isSameUser = (a: UserIdentifier, b: UserIdentifier): boolean => {
  if (a == null || b == null) {
    return false;
  }
  const left = String(a);
  return left !== "" && left === String(b);
};
